import * as types from "./mutation-type";

export default {
    [types.SET_ITEMS_WISHLIST](state, payload) {
        state.itemsWishlist = payload
    },
    [types.SET_PAGINATION](state, payload) {
        state.pagination = payload
    },
    [types.SET_COUNT_ITEMS_WISHLIST](state, payload) {
        state.countItemsWishlist = payload
    },
}
